import React from "react";
import { connect } from "react-redux";
import './FileUpload.css';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
//import readXlsxFile from 'read-excel-file';
import { CSVLink } from "react-csv";
const httpClient = axios.create();
class FileUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			selectedFile: null,
			fileProcess: '',
			bulkUploadHistory: [],
			status: '',
			message: '',
			totalRecords: '',
			fileName: '',
			started1: '',
			started2: '',
			started3: '',
			recordList: []
		}
	}

	resList = [];
	count = []

	componentDidMount() {
		this.loadBillerParamerts();

	}
	componentWillUnmount() {
	}




	csvToArray(str, delimiter = ",") {
		var array = str.split("\\r\\n").map(function (line) {
			return line.split(delimiter);
		});

		return array;
	}

	loadBillerParamerts = () => {
		var loadBillerUrl = '/api/v1/catalog/billpay/biller/by-category/';

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		var billerConfig = {
			id: '',
			operator: '',
			state: '',
			category: '',
			questions: [],
			endpoint: ''
		}

		var billerConfigList = [];
		var billerInfoList = [];

		var resList = [];
		httpClient.post(loadBillerUrl + 'ELECTRICITY', '',
			{ headers }
		).then((response) => {


			if (response.data != null &&
				response.data != undefined &&
				response.data != '') {
				if (response.data.length > 0) {
					response.data.map(res => {
						this.resList.push(res)
					})

				}
			}
			setTimeout(() => {
				this.setState({
					started1: 'finish'
				})
			}, 200);


		}).catch(error => {
			this.setState({
				started1: 'finish'
			})
		});
		httpClient.post(loadBillerUrl + 'WATER', '',
			{ headers }
		).then((response) => {

			if (response.data != null &&
				response.data != undefined &&
				response.data != '') {
				if (response.data.length > 0) {
					response.data.map(res => {
						this.resList.push(res)
					})

				}
			}
			setTimeout(() => {
				this.setState({
					started2: 'finish'
				})
			}, 200);
		}).catch(error => {
			this.setState({
				started2: 'finish'
			})
		});
		httpClient.post(loadBillerUrl + 'GAS', '',
			{ headers }
		).then((response) => {

			if (response.data != null &&
				response.data != undefined &&
				response.data != '') {
				if (response.data.length > 0) {
					response.data.map(res => {
						this.resList.push(res)
					})

				}
			}
			setTimeout(() => {
				this.setState({
					started3: 'finish'
				})
			}, 200);
		}).catch(error => {
			this.setState({
				started3: 'finish'
			})
		});




	}
	uploadDoc = (event) => {


		if (event != null) {
			if (event.target != null) {

				if (event.target.files[0].type.includes("spreadsheet") ||
					event.target.files[0].type.includes("application/vnd.ms-excel")) {
					if (parseInt(event.target.files[0].size / 1000) < 10 * 1024) {

						if (event.target.files[0] != null) {
							var lineArray = [];
							var rows = [];
							console.log('event.target.files[0]' + URL.createObjectURL(event.target.files[0]));
							this.setState({
								selectedFile: URL.createObjectURL(event.target.files[0])
							});


							// if (event.target.files[0].type.includes("application/vnd.ms-excel")) {
							// 	try {
							// 		const reader = new FileReader();
							// 		const file = event.target.files[0];
							// 		reader.onload = (e) => {

							// 			const cvsData = e.target.result;
							// 			const rowData = cvsData.split('\n');
							// 			rowData.map(row => {
							// 				if (row.includes(",,,,,,,,,")) {

							// 				} else {
							// 					rows.push(row)
							// 				}
							// 			})


							// 			if (rows.length > 0 &&
							// 				rows.length <= 100) {
							// 				this.onFileUpload(
							// 					file
							// 					, rows.length
							// 					, file.type);
							// 			} else {
							// 				alert('Please upload MIN 1 /MAX 100 records at once...');
							// 			}


							// 		};
							// 		reader.readAsText(event.target.files[0])
							// 	} catch (error) {
							// 		alert(error.message)
							// 	}

							// }
							// setTimeout(() => {
							// 	alert(rows.length)

							// }, 1000);


							// if (event.target.files[0].type.includes("spreadsheet")) {
							// 	readXlsxFile(event.target.files[0]).then((data) => {

							// 		data.forEach(function (infoArray, index) {
							// 			var line = infoArray.join(",");
							// 			if (index != 0) {
							// 				lineArray.push(line);
							// 			}
							// 			// lineArray.push(index == 0 ? "data:text/csv;charset=utf-8," + line : line);
							// 		});

							// 		// alert(JSON.stringify(lineArray))

							// 		lineArray.map(row => {
							// 			if (row.includes(",,,,,,,,,")) {

							// 			} else {
							// 				rows.push(row)
							// 			}
							// 		})

							// 		if (rows.length > 0 &&
							// 			rows.length <= 100) {
							// 			this.onFileUpload(
							// 				event.target.files[0]
							// 				, rows.length
							// 				, event.target.files[0].type);

							// 		} else {
							// 			alert('Please upload MIN 1 /MAX 100 records at once...');
							// 		}


							// 	}).catch(error => {
							// 		alert(error.message)
							// 	});


							// }

							this.onFileUpload(
								event.target.files[0]
								, event.target.files[0].type);

						}
					} else {
						console.log("file size is greater than 10 MB");
						this.setState({
							uploadErrorMessage: 'file size is greater than 10 MB'
						})
					}
				} else {
					console.log("file type is::" + event.target.files[0].type + "-not supported");

				}
			}
		}
	}

	onFileUpload = (value,
		type) => {
		var fileName = uuidv4();
		var requesterId = this.props.clientRequesterId;
		this.setState({
			progress: 0,
			fileProcess: 'started'
		})
		console.log('file name::' + fileName);

		const formData = new FormData();
		formData.append(
			"document", value
		);
		formData.append(
			"agentId", this.props.agentInfo
		);
		var typeVal = "";
		if (type.includes("spreadsheet")) {
			typeVal = "excel"
		}
		if (type.includes("application/vnd.ms-excel")) {
			typeVal = "csv"
		}
		formData.append(
			"type", typeVal
		);
		formData.append(
			"requesterId", requesterId
		);
		formData.append(
			"fileName", fileName
		);

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo
			, 'role': this.props.clientRole
		}
		fetch('/api/v1/billpay/corp/consumer/upload', {
			method: 'post',
			body: formData,
			headers: headers
		}).then(res => res.json())
			.then(data => {
				this.setState({
					fileName: data.fileName,
					fileProcess: 'completed'
				})

			}).catch(errorx => {

				console.log('file upload error..' + errorx.message);
				this.setState({
					message: errorx.message,
					fileProcess: 'failed'
				})
			});
	}


	sample = () => {
		this.setState({
			recordList: []
		})
		var recordList = [];

		if (this.resList.length > 0) {
			this.resList.map(res => {

				var billerCategory=res.category;
				var operator = res.id;
				var billerName = res.operator;
				var questions = res.questions;
				var optional = '';
				questions.map(q => {
					var optionalPram = q.optionalField;
					optional = optional + optionalPram + ";"
				})

				var spBillers = process.env.REACT_APP_SPECIALBILLER;
				var optional1 = "";

				var record = {
					billerCategory:billerCategory,
					operator: operator,
					billerName: billerName,
					optional: optional.replace(";", ",") 
				}
				

				recordList.push(record);

				this.setState({
					recordList: recordList
				})


			})

			setTimeout(() => {
				var csvLink = document.getElementById('csvLink');
				csvLink.click();
			}, 300);

		}

	}


	render() {

		return (


			<div>
				<div class="dashhead">
					<h3>Upload Consumers</h3>
					<a href="images/industry2.2.xlsx" class="sample">Sample file</a>

					{this.state.recordList.length == 0 &&
						this.state.started1 == 'finish' &&
						this.state.started2 == 'finish' &&
						this.state.started3 == 'finish' &&
						<button class="sample" onClick={this.sample}>Download Operator Code File</button>
					}
					{this.state.recordList.length > 0 &&
						<CSVLink
							class="sample"
							id="csvLink"
							data={this.state.recordList}
							asyncOnClick={true}
							// onClick={this.resetExportDate}
							filename={"List_Opeator_codes" + ".csv"}
						>
							Download Operator Code File
						</CSVLink>
					}


				</div>

				<div class="file-upload">
					<div class="dropzone-wrapper">
						<div class="dropzone-desc">
							<i class="camera"></i>
							<h6>Drag & Drop or <span>Browes</span> file</h6>
							<p>File: csv, exl and max size 10 MB</p>
						</div>
						{(this.state.fileProcess != 'started') &&
							<input type="file" name="fileup" class="dropzone"
								onChange={e => this.uploadDoc(e)} />
						}

					</div>

					<div class="preview-zone hidden">
						<div class="box">

							<div class="progress" style={{ height: 6 + "px;" }}>
								<div class="progress-bar" role="progressbar"
									style={{ width: 25 + "%;" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
							</div>
							<div class="box-body"></div>
							<button type="button" class="remove-preview">Remove</button>
						</div>
					</div>

					{this.state.fileProcess == 'completed' &&
						<div class='valid-success'>
							<p>File is uploaded. </p>
							<p>Id: {this.state.fileName}.</p>
							<p>Please check upload history later for final status.</p>
						</div>}
					{(this.state.fileProcess == 'started') &&
						<div class='valid-success'><center>File is processing..please wait!</center></div>}

				</div>
			</div >


		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, agentInfo, token, clientRole,clientRequesterId } }
) => ({
	errorMessage, phone, agentInfo, token, clientRole,clientRequesterId
});

export default connect(mapStateToProps, null)(FileUpload);
